import React, { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { FormattedMessage, useIntl } from "react-intl";
import ApiServices from "../../../service/apiService";
import {
  CohortModel,
  CohortUser,
  FetchAllUsers,
  FetchCohorts,
  GetUsers,
  MemberData,
  UserResourceModel,
} from "@mikros/library";
import {
  Grid,
  GridColumn,
  GridHeaderSelectionChangeEvent,
  GridPageChangeEvent,
  GridSelectionChangeEvent,
  GridSortChangeEvent,
} from "@progress/kendo-react-grid";
import {
  PagerTargetEvent,
  getSelectedState,
} from "@progress/kendo-react-data-tools";
import { TextArea, TextBox } from "@progress/kendo-react-inputs";
// import { AddNewUsers } from "./addNewUsers";
import { getter } from "@progress/kendo-react-common";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "@mikros/shared-ui";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { SortDescriptor, orderBy } from "@progress/kendo-data-query";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { AddFilterUser } from "./addFilterUser";
// import { AddNewUsersDup } from "./addNewUsersDup";

export interface CohortListDupProps {
  currentCohort: CohortModel;
  coh: FetchCohorts;
  onReload: () => void;
  cohortListState: Function;
  addNewState: Function;
  refreshedCohorts: () => void;
}

interface PageState {
  pageNumber: number;
  skip: number;
  take: number;
}
const initialDataState: PageState = { pageNumber: 1, skip: 0, take: 10 };

export function CohortListDup(props: CohortListDupProps) {
  const DATA_ITEM_KEY: string = "userId";
  const SELECTED_FIELD: string = "selected";
  const idGetter = getter(DATA_ITEM_KEY);
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const [showAddNewUser, setShowAddNewUser] = useState(false);

  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const [fetchCohorts, setFetchChorts] = useState<FetchCohorts>({
    cohortUsers: [{} as CohortUser],
  } as FetchCohorts);
  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [currCohort, setCurrCohort] = useState<CohortModel>(
    props.currentCohort
  );
  const [delDialog, setDelDialog] = React.useState<boolean>(false);
  const [successDialog, setSuccessDialog] = React.useState<boolean>(false);
  const [pageSelectedState, setPageSelectedState] = useState({});

  const [filteredData, setFilteredData] = useState<any>([]);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const toggledelDialog = () => {
    setDelDialog(!delDialog);
  };

  const toggleSuccessDialog = () => {
    setSuccessDialog(!successDialog);
  };

  const toTitleCase = (value: any) => {
    if (typeof value === "string") {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return value ?? ""; // Return the original value if not a string, or "N/A" if null/undefined
  };
  console.log("selected states print", selectedState);

  console.log("current cohort in cohort list", props.currentCohort);

  const compData = fetchCohorts?.cohortUsers?.map((item) => ({
    ...item,
    [SELECTED_FIELD]: selectedState[idGetter(item)],
  }));

  console.log("Comp data", selectedState);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value === intl.formatMessage({ id: "allValue" })
        ? compData.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage((prevPage) => ({
      ...prevPage,
      ...event.page,
      take,
    }));
  };

  const intl = useIntl();
  const [showCohortDetails, setShowCohortDetails] = useState(true);
  const [showDelBut, setShowDelBut] = useState(true);
  const [user, setUser] = useState<UserResourceModel>({
    resources: [{} as GetUsers],
  } as UserResourceModel);

  const initialSort: Array<SortDescriptor> = [{ field: "empId", dir: "asc" }];
  const [sort, setSort] = useState(initialSort);

  const handleAddNewUserClick = () => {
    console.log("inside handle add new user click");
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }

          const response = res?.resources?.map((ele: GetUsers) => {
            let currentUser = ele;
            const tempdate = new Date(
              Date.parse(ele?.dateOfJoin?.split("T")[0])
            );
            const tempDob = new Date(
              Date.parse(ele?.userProfile?.dob?.split("T")[0])
            );
            currentUser.joiningDate = new Date(
              tempdate.getFullYear(),
              tempdate.getMonth(),
              tempdate.getDate()
            );
            currentUser.userProfile.dateOfBirth = new Date(
              tempDob.getFullYear(),
              tempDob.getMonth(),
              tempDob.getDate()
            );
            return currentUser;
          });

          const res1 = {
            resources: response,
            resourceCount: res.resourceCount,
          };
          setUser(res1);
        });
    }

    setShowAddNewUser(true);
    setShowCohortDetails(false);
    setShowDelBut(false);
  };

  const handleScheduleCohortNavigation = () => {
    if (
      !props.currentCohort?.cohortId ||
      props.currentCohort.status !== "ACTIVE" ||
      !Array.isArray(fetchCohorts?.cohortUsers) ||
      fetchCohorts.cohortUsers.length < 1
    ) {
      return;
    }

    const cohortToSchedule = {
      cohortId: props.currentCohort.cohortId,
      accntId: props.currentCohort.accntId,
      cohortName: props.currentCohort.cohortName,
      description: props.currentCohort.description,
      status: props.currentCohort.status,
      cohortType: props.currentCohort.cohortType,
      cohortuserCnt: props.currentCohort.cohortuserCnt,
      entityId: props.currentCohort.entityId,
      recType: props.currentCohort.recType,
      createdBy: props.currentCohort.createdBy,
      updatedBy: props.currentCohort.updatedBy,
      date: props.currentCohort.date,
    };

    navigate("/newSchedule", {
      state: JSON.stringify({ cohortToSchedule }),
    });
  };

  console.log("currentChort", props.currentCohort);
  useEffect(() => {
    if (!props.currentCohort?.cohortId) {
      console.error("Cohort ID is missing, skipping API call.");
      return;
    }
    if (props.currentCohort) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/cohort/${props.currentCohort.cohortId}`,
            "GET"
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              console.log("GET response error message", res);
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }

            console.log("s res", res);

            setFetchChorts(res);
            props.cohortListState(true);
            console.log("Get response", res);
            console.log("Cohort name field", props.currentCohort.cohortName);
          });
      }
    }
  }, [props.currentCohort, accountInstance.accntId]);

  const onSelectionChange = (event: GridSelectionChangeEvent) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);
  };

  const formatDateOfJoin = (dateString: any) => {
    const date = new Date(dateString);

    const formattedDate = format(date, "dd/MM/yyyy");
    return formattedDate;
  };

  const formatDateOfBirth = (dateString: Date) => {
    console.log("received date string", dateString);

    const date = new Date(dateString);

    console.log("parsed date object", date);

    const formattedDate = format(date, "dd/MM/yyyy");
    console.log("formatted date", formattedDate);
    return formattedDate;
  };
  const onHeaderSelectionChange = (event: GridHeaderSelectionChangeEvent) => {
    const checkboxElement: any = event.syntheticEvent.target;
    const checked = checkboxElement.checked;

    const newSelectedState: { [id: string]: boolean } = {};

    compData.slice(page.skip, page.take + page.skip).forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setPageSelectedState((prevPageSelectedState: any) => ({
      ...prevPageSelectedState,
      [page.pageNumber]: {
        ...(prevPageSelectedState[page.pageNumber] || {}),
        ...newSelectedState,
      },
    }));

    setSelectedState((prevSelectedState) => ({
      ...prevSelectedState,
      ...newSelectedState,
    }));

    setFilteredData((prevFilteredData: any) =>
      prevFilteredData.map((item: any) => ({
        ...item,
        [SELECTED_FIELD]: newSelectedState[idGetter(item)],
      }))
    );
  };

  async function addUpdate(currentCohort: CohortModel) {
    console.log("Check if in addUpdate");
    if (props.currentCohort) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        await api
          .makeRequest(
            `${accountInstance.accntId}/cohort/${props.currentCohort.cohortId}`,
            "GET"
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }

            console.log("s res", res);
            setFetchChorts(res);
            console.log("Get response", res);
            console.log("Cohort name field", props.currentCohort.cohortName);
          });
      }
    }
  }
  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      <div>
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                if (errorInstance.permDenied === true) {
                  navigate("/home");
                } else {
                  navigate("/users");
                }
              }}
            />
          </Dialog>
        )}

        {showAddNewUser && (
          //   <AddNewUsers
          //     cohortListState={setShowCohortDetails}
          //     addNewState={setShowAddNewUser}
          //     addNewUpdate={() => {
          //       addUpdate(currCohort);
          //     }}
          //     currentCohort={currCohort}
          //     coh={fetchCohorts}
          //     delBut={setShowDelBut}
          //     refreshedCohorts={() => {
          //       props.refreshedCohorts();
          //     }}
          //   />
          <div>
            <AddFilterUser
              cohortListState={setShowCohortDetails}
              addNewState={setShowAddNewUser}
              addNewUpdate={() => {
                addUpdate(currCohort);
              }}
              currentCohort={currCohort}
              coh={fetchCohorts}
              delBut={setShowDelBut}
              refreshedCohorts={() => {
                props.refreshedCohorts();
              }}
            />

            {/* <AddNewUsersDup
              cohortListState={setShowCohortDetails}
              addNewState={setShowAddNewUser}
              addNewUpdate={() => {
                addUpdate(currCohort);
              }}
              currentCohort={currCohort}
              coh={fetchCohorts}
              delBut={setShowDelBut}
              refreshedCohorts={() => {
                props.refreshedCohorts();
              }}
            /> */}
          </div>
        )}
        {showCohortDetails && (
          <div>
            <div className="w-full flex flex-col gap-4 mt-[3.5rem] md:flex-row md:items-end md:justify-between">
              <div className="w-full">
                <div className="font-bold">
                  {/* Give a name to the cohort*
                   */}
                  <FormattedMessage id="user.searchCriteria.nameToCohort"></FormattedMessage>
                </div>
                <TextBox
                  valid={true}
                  className="w-[30%]"
                  value={props.currentCohort.cohortName}
                  disabled={true}
                />
              </div>
              
            </div>

            <div className="mb-4">
              <div className="font-bold">
                <FormattedMessage id="user.searchCriteria.description"></FormattedMessage>
              </div>

              <TextArea
                valid={true}
                rows={3}
                cols={80}
                className="w-[30%]"
                value={props.currentCohort.description}
                disabled={true}
              />
            </div>
          </div>
        )}
      </div>
      {successDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "user.cohortList.deleteUsersSuccess",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              if (props.currentCohort) {
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/cohort/${props.currentCohort.cohortId}`,
                      "GET"
                    )
                    .then(async (res) => {
                      if (res && res.errorMessage) {
                        setErrorFlag(true);
                        await errorInstance.updateErrorCode(res.errorMessage);
                        return;
                      }

                      console.log("s res", res);
                      setFetchChorts(res);
                      console.log("Get response", res);
                      console.log(
                        "Cohort name field",
                        props.currentCohort.cohortName
                      );
                      toggleSuccessDialog();
                    });
                }
              }
              toggleSuccessDialog();
            }}
          />
        </Dialog>
      )}

      {delDialog && (
        <Dialog className="warningDialogue">
          <Confirm
            description={intl.formatMessage({
              id: "users.cohortList.deletionMessage",
            })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon={"warningShape.png"}
            iconMsg={"Warning!"}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              let body: MemberData = {
                //@ts-ignore
                cohortData: {},
                users: [],
              };
              body.cohortData.entityId = accountInstance.accntId;
              body.cohortData.recType =
                "Cohort_" + props.currentCohort.cohortId;
              body.cohortData.accntId = accountInstance.accntId;

              body.cohortData.cohortId = props.currentCohort.cohortId;
              body.cohortData.cohortName = props.currentCohort.cohortName;
              body.cohortData.cohortType = "STATIC";
              body.cohortData.createdAt = 1690218282640;
              body.cohortData.createdBy =
                "40c60358-adf4-415c-bed3-f542efd4bbc6";
              body.cohortData.date = "2023-07-24T17:04:42Z";
              body.cohortData.description = props.currentCohort.description;
              body.cohortData.entryType = "COHORT";
              body.cohortData.status = "ACTIVE";
              body.cohortData.updatedAt = 1690218734168;
              body.cohortData.updatedBy =
                "2f413330-4cc7-49a8-94f6-6ae2e894260e";

              let user = fetchCohorts;
              let userData = body.users;

              body.users = user.cohortUsers;
              console.log("User data initial", body.users);
              console.log("Body user data inital in delete", body.users);
              const selectedKeys = Object.keys(selectedState);
              console.log("Print selected state", selectedState);
              console.log("Selected key in cohortList", selectedKeys);
              selectedKeys.forEach((key) => {
                if (selectedState[key]) {
                  console.log("if condition", selectedState[key]);
                  const delUser = {
                    userId: key,
                    empId: selectedState[key].toString(),
                  };
                  console.log("New user data in delete", delUser);
                }
              });

              console.log("after assign of user data", body.users);

              console.log("Selected state keys:", Object.keys(selectedState));
              console.log("initial user data", body.users);

              let initialLength = body.users.length;

              const updatedUserData = body.users.filter(
                (user) => selectedState[user.userId]
              );

              body.users = updatedUserData;

              body.cohortData.cohortuserCnt = initialLength;
              console.log(
                "updated user data lenght",
                body.cohortData.cohortuserCnt
              );

              console.log("updated user data check", body.users);

              let api = ApiServices.getInstance();
              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/cohort/${props.currentCohort.cohortId}/removemember`,
                    "PUT",
                    body
                  )
                  .then(async (body) => {
                    if (body && body.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(body.errorMessage);
                      return;
                    }

                    console.log("");
                    console.log("Create form response delete", body);
                    toggleSuccessDialog();
                  });
              }
              console.log("Selected state keys structure", selectedKeys);
              toggledelDialog();
              setSelectedState({});
            }}
            onFailure={() => {
              toggledelDialog();
              setSelectedState({});
            }}
          />
        </Dialog>
      )}
      {showCohortDetails && (
        <div>
          <div className="flex justify-between items-end">
            <div className="text-mk-primary-bright text-xl font-semibold">
              <FormattedMessage id="cohortUser.title" />
            </div>
            {showCohortDetails && (
              <div className="flex gap-4">
                <Button
                  className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                  onClick={handleAddNewUserClick}
                >
                  <FormattedMessage id="user.cohortList.addNewUsers"></FormattedMessage>
                </Button>
                <Button
                  themeColor={"primary"}
                  onClick={handleScheduleCohortNavigation}
                  disabled={
                    !props.currentCohort.cohortId ||
                    props.currentCohort.status !== "ACTIVE" ||
                    !Array.isArray(fetchCohorts?.cohortUsers) ||
                    fetchCohorts.cohortUsers.length < 1
                  }
                >
                  <FormattedMessage id="users.cohortList.scheduleCohort" />
                </Button>
              </div>
            )}
          </div>
          <div className="mt-4">
            {compData && (
              <Grid
                style={{ border: 0 }}
                rowHeight={48}
                data={orderBy(
                  compData.slice(page.skip, page.take + page.skip),
                  sort
                )}
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                selectable={{
                  enabled: true,
                  drag: false,
                  cell: false,
                  mode: "multiple",
                }}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                onPageChange={pageChange}
                skip={page.skip}
                take={page.take}
                total={compData.length}
                sortable={true}
                sort={sort}
                onSortChange={(e: GridSortChangeEvent) => {
                  setSort(e.sort);
                }}
                pageable={{
                  buttonCount: 4,
                  pageSizes: [
                    5,
                    10,
                    15,
                    intl.formatMessage({ id: "allValue" }),
                  ],
                  pageSizeValue: pageSizeValue,
                }}
              >
                <GridColumn
                  field={SELECTED_FIELD}
                  headerSelectionValue={
                    compData
                      .slice(page.skip, page.take + page.skip)
                      .findIndex(
                        (item: any) => !selectedState[idGetter(item)]
                      ) === -1
                  }
                  headerClassName="custom-header"
                />
                <GridColumn
                  field="userProfile.firstName"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.fname",
                  })}
                  width="150px"
                  cell={(props) => (
                    <td>{props.dataItem.userProfile?.firstName}</td>
                  )}
                />
                <GridColumn
                  field="userProfile.lastName"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.lname",
                  })}
                  width="100px"
                  cell={(props) => (
                    <td>{props.dataItem.userProfile?.lastName}</td>
                  )}
                />

                <GridColumn
                  field="status"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.status",
                  })}
                  width="85px"
                  cell={(props) => (
                    <td>
                      {props?.dataItem?.status &&
                        props?.dataItem?.status.charAt(0).toUpperCase() +
                          props?.dataItem?.status.slice(1).toLowerCase()}
                    </td>
                  )}
                />
                <GridColumn
                  field="prefrdLanguage"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.language",
                  })}
                  width="125px"
                  cell={(props) => <td>{props.dataItem?.prefrdLanguage}</td>}
                />
                <GridColumn
                  field="phNo"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.phNo",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem?.phNo}</td>}
                />

                <GridColumn
                  field="email"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.email",
                  })}
                  width="200px"
                  cell={(props) => <td>{props.dataItem?.email}</td>}
                />

                <GridColumn
                  field="empId"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.employee",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem.empId}</td>}
                />
                <GridColumn
                  field="userProfile.dob"
                  resizable={true}
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.dob",
                  })}
                  width="125px"
                  cell={(props) => (
                    <td>
                      {props?.dataItem?.userProfile?.dob &&
                        formatDateOfBirth(props?.dataItem?.userProfile?.dob)}
                    </td>
                  )}
                />

                <GridColumn
                  field="dateOfJoin"
                  resizable={true}
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.dateOfJoin",
                  })}
                  width="125px"
                  cell={(props) => (
                    <td>
                      {props?.dataItem?.dateOfJoin &&
                        formatDateOfJoin(props?.dataItem?.dateOfJoin)}
                    </td>
                  )}
                />

                <GridColumn
                  field="lastWorkingDate"
                  resizable={true}
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.lastWorkingDate",
                  })}
                  width="125px"
                  cell={(props) => (
                    <td>
                      {props?.dataItem?.lastWorkingDate &&
                        formatDateOfJoin(props?.dataItem?.lastWorkingDate)}
                    </td>
                  )}
                />

                <GridColumn
                  field="userProfile.gender"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.gender",
                  })}
                  width="85px"
                  cell={(props) => (
                    <td>{toTitleCase(props.dataItem.userProfile?.gender)}</td>
                  )}
                />

                <GridColumn
                  field="department"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.department",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem?.department}</td>}
                />
                <GridColumn
                  field="designation"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.desg",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem?.designation}</td>}
                />
                <GridColumn
                  field="location"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.location",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem?.location}</td>}
                />
                <GridColumn
                  field="branchName"
                  title={intl.formatMessage({
                    id: "user.searchUser.gridColumn.branch",
                  })}
                  width="150px"
                  cell={(props) => <td>{props.dataItem?.branchName}</td>}
                />
              </Grid>
            )}
          </div>
        </div>
      )}

      <div className="flex justify-between items-end">
        <div></div>
        {showDelBut && (
          <div className="flex justify-center mt-4 gap-4">
            <Button
              className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                hover:text-black focus:outline-none px-4 py-2"
              onClick={toggledelDialog}
              disabled={
                Object.keys(selectedState).length === 0 ||
                Object.values(selectedState).every((value) => !value)
              }
            >
              <FormattedMessage id="user.cohortList.deleteSelected"></FormattedMessage>
            </Button>
            {/* <Button
              className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey

                                hover:text-black focus:outline-none px-4 py-2"
            >
              <FormattedMessage id="user.cohortList.save"></FormattedMessage>
            </Button> */}
          </div>
        )}
      </div>
    </div>
  );
}
